// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3iJv-","footer":"ModalUpdate_footer__1uHsg"};